module.exports = __webpack_public_path__ + "images/11b861cc7c72604c83c558f34d55cf53cb.svg";